var locale = {
  // Options
  items_per_page: '/ စာမျက်နှာ',
  jump_to: 'သွားရန်',
  jump_to_confirm: 'သေချာပြီ',
  page: '',
  // Pagination
  prev_page: 'ယခင်စာမျက်နှာ',
  next_page: 'နောက်စာမျက်နှာ',
  prev_5: 'ယခင် ၅ခုမြောက်',
  next_5: 'နောက် ၅ခုမြောက်',
  prev_3: 'ယခင် ၃ခုမြောက်',
  next_3: 'နောက် ၃ခုမြောက်',
  page_size: 'Page Size'
};
export default locale;